import React, { FC } from 'react';
import AuthPage from './AuthPage';

const VerifyAccount: FC = () => <AuthPage initialScreen="verify" />;

export default VerifyAccount;
